import { useEffect } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom'

import { ROUTE_PATHS } from 'routes'

function StripeCancelPage(): JSX.Element {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	useEffect(() => {
		// Extract any error or cancellation reason from URL params
		const reason = searchParams.get('reason') || 'Payment was cancelled'
		const sessionId = searchParams.get('session_id')

		// Redirect to account settings with notification data
		navigate(ROUTE_PATHS.ACCOUNT.SETTINGS, {
			state: {
				notification: {
					type: 'warning',
					message: reason,
					title: 'Payment Cancelled',
					sessionId: sessionId,
				},
			},
		})
	}, [navigate, searchParams])

	// Return a loading state while redirecting
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
			}}
		>
			<p>Redirecting...</p>
		</div>
	)
}

export default StripeCancelPage
